(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[914,342],{

/***/ 57164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/event2",
      function () {
        return __webpack_require__(86935);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _stores_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62010);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72619);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81627);









/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var children = param.children, _banner = param.banner, banner = _banner === void 0 ? "https://img.cbcechina.com/2026-04-22/e7c5f665458295d9f78d069a0f4dd0a7.png" : _banner, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#ffffff" : _bgColor, _bgImage = param.bgImage, bgImage = _bgImage === void 0 ? "/image/page-bg.png" : _bgImage, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _showCrumb = param.showCrumb, showCrumb = _showCrumb === void 0 ? true : _showCrumb, _showPendant = param.showPendant, showPendant = _showPendant === void 0 ? true : _showPendant;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_7__/* .useTranslations */ .T_)("wrapper");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_stores_index__WEBPACK_IMPORTED_MODULE_5__/* .IndexContext */ .Z), menuCurrent = ref1.menuCurrent, menuParent = ref1.menuParent;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHidePendant = ref2[0], setIsHidePendant = ref2[1];
    var toTop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        style: {
            backgroundColor: bgColor,
            backgroundImage: "url(".concat(bgImage, ")")
        },
        children: [
            banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cover),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: banner,
                        alt: "banner",
                        loading: "lazy"
                    })
                })
            }),
            showCrumb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().crumb), "m-1600"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                src: "/image/home.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: "_self",
                                                children: router.locale == "en" ? "Home" : "首页"
                                            })
                                        })
                                    }),
                                    menuParent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: (menuParent === null || menuParent === void 0 ? void 0 : menuParent._href) || "/",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: (menuParent === null || menuParent === void 0 ? void 0 : menuParent._target) || "_self",
                                                children: menuParent === null || menuParent === void 0 ? void 0 : menuParent._title
                                            })
                                        })
                                    }),
                                    menuCurrent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item), router.pathname === (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._href) ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._href) || "/",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._target) || "_self",
                                                children: menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent._title
                                            })
                                        })
                                    }),
                                    crumb === null || crumb === void 0 ? void 0 : crumb.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item), item.isActive ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: item.path,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_self",
                                                    children: item.name
                                                })
                                            })
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                            children: menuParent === null || menuParent === void 0 ? void 0 : (ref = menuParent.childlist) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item), router.pathname === (item === null || item === void 0 ? void 0 : item._href) ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: (item === null || item === void 0 ? void 0 : item._href) || "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: (item === null || item === void 0 ? void 0 : item._target) || "_self",
                                            children: item === null || item === void 0 ? void 0 : item._title
                                        })
                                    })
                                }, item === null || item === void 0 ? void 0 : item.id);
                            })
                        })
                    })
                ]
            }),
            showPendant && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().pendant), isHidePendant ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hidden) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Popover */ .J2, {
                                showArrow: true,
                                style: {
                                    backgroundColor: "#F9B000",
                                    padding: "15px",
                                    width: "230px"
                                },
                                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            style: {
                                                width: "100%"
                                            },
                                            src: "/image/help-qrcode.png",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                fontSize: "14px",
                                                color: "#ffffff",
                                                textAlign: "center",
                                                marginTop: "5px"
                                            },
                                            children: "更多资讯，关注CBCE小助手"
                                        })
                                    ]
                                }),
                                position: "left",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/wechat.png",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t.rich("pendant.item1tit", {
                                                    br: function() {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/exhibition/apply",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                                        target: "_self",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/user1.png",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t.rich("pendant.item2tit", {
                                                    br: function() {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: router.locale == "cn" ? "https://cbce2025.expotec-group.com/?member/register&code=sites" : "https://cbce2025.expotec-group.com/?member/register&lang=en",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/group.png",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t.rich("pendant.item3tit", {
                                                    br: function() {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                                    onClick: toTop,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/image/arrow-up.png",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: t.rich("pendant.item4tit", {
                                                br: function() {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().close),
                        onClick: function() {
                            return setIsHidePendant(!isHidePendant);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                t: "1723196878237",
                                className: "icon",
                                viewBox: "0 0 1024 1024",
                                version: "1.1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "p-id": "2672",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                    "p-id": "2673",
                                    fill: "#fff"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("pendant.hidden")
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};


/***/ }),

/***/ 86935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99967);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_wrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65409);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);













var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var menuDetail = param.menuDetail, data = param.data;
    var ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_10__/* .useTranslations */ .T_)("schedule.event2");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTimeout(function() {
            var ref;
            var str = ((ref = document.getElementById("reactCode")) === null || ref === void 0 ? void 0 : ref.innerText) || "console.log()";
            eval(str);
        }, 0);
    }, [
        menuDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
                    "m-1600"
                ]),
                children: [
                    (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_8__/* .getHead */ .c)(menuDetail),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("text")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().photo),
                        children: [
                            !!(data === null || data === void 0 ? void 0 : (ref = data.list) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().photoList),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().top),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data === null || data === void 0 ? void 0 : data.list[0]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data === null || data === void 0 ? void 0 : data.list[0]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data === null || data === void 0 ? void 0 : data.list[1]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data === null || data === void 0 ? void 0 : data.list[1]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data === null || data === void 0 ? void 0 : data.list[2]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data === null || data === void 0 ? void 0 : data.list[2]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data === null || data === void 0 ? void 0 : data.list[3]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data === null || data === void 0 ? void 0 : data.list[3]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().bottom),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data === null || data === void 0 ? void 0 : data.list[4]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data === null || data === void 0 ? void 0 : data.list[4]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data === null || data === void 0 ? void 0 : data.list[5]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data === null || data === void 0 ? void 0 : data.list[5]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data === null || data === void 0 ? void 0 : data.list[6]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data === null || data === void 0 ? void 0 : data.list[6]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data === null || data === void 0 ? void 0 : data.list[7]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data === null || data === void 0 ? void 0 : data.list[7]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data === null || data === void 0 ? void 0 : data.list[8]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data === null || data === void 0 ? void 0 : data.list[8]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/media/photo",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().more),
                                            "btnStyle"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: t("more")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                t: "1723196878237",
                                                className: "icon",
                                                viewBox: "0 0 1024 1024",
                                                version: "1.1",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                "p-id": "2672",
                                                width: "14",
                                                height: "14",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                    "p-id": "2673",
                                                    fill: "#231F20"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: menuDetail === null || menuDetail === void 0 ? void 0 : (ref = menuDetail.info) === null || ref === void 0 ? void 0 : ref.content
                        }
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getMenuCurrent = function(menu, path) {
    for(var i = 0; i < (menu === null || menu === void 0 ? void 0 : menu.length); i++){
        var item = menu[i];
        if (item.pathinfo === path) {
            return item;
        }
        if (item.childlist && Array.isArray(item.childlist)) {
            var child = getMenuCurrent(item.childlist, path);
            if (child) {
                return child;
            }
        }
    }
    return null;
};
var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context, menuId) {
        var ref, ref1, ref2, _menu, menuCurrent, ref3, _data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/api/menu", {
                            params: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    ref2 = _state.sent(), _menu = ref2.data;
                    menuCurrent = getMenuCurrent(_menu === null || _menu === void 0 ? void 0 : (ref = _menu.data) === null || ref === void 0 ? void 0 : ref.menu_tree, context === null || context === void 0 ? void 0 : (ref1 = context.resolvedUrl) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0]);
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/api/menu_info/".concat(menuId || (menuCurrent === null || menuCurrent === void 0 ? void 0 : menuCurrent.id)), {
                            params: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 2:
                    ref3 = _state.sent(), _data = ref3.data;
                    return [
                        2,
                        {
                            props: {
                                menuDetail: _data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context, menuId) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref = menuDetail.info) === null || ref === void 0 ? void 0 : ref.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: menuDetail === null || menuDetail === void 0 ? void 0 : (ref1 = menuDetail.info) === null || ref1 === void 0 ? void 0 : ref1.meta_title
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref2 = menuDetail.info) === null || ref2 === void 0 ? void 0 : ref2.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : (ref3 = menuDetail.info) === null || ref3 === void 0 ? void 0 : ref3.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : (ref4 = menuDetail.info) === null || ref4 === void 0 ? void 0 : ref4.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : (ref5 = menuDetail.info) === null || ref5 === void 0 ? void 0 : ref5.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 72619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"styles_m-1600__ecGnv","wrapper":"styles_wrapper__j3z_P","banner":"styles_banner__HoQ_B","cover":"styles_cover__tIXjm","crumb":"styles_crumb__nIPeb","left":"styles_left__iFfQG","list":"styles_list__DK1TD","item":"styles_item__NZXlU","active":"styles_active__1TT_9","right":"styles_right__zr2NE","pendant":"styles_pendant____0eJ","hidden":"styles_hidden___wUtq","close":"styles_close__ZN10T"};

/***/ }),

/***/ 99967:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"event2_m-1600__SLZa3","container":"event2_container__WEb4O","photo":"event2_photo__0vmF1","more":"event2_more__5DTtQ","photoList":"event2_photoList__RktrH","top":"event2_top__C5WTY","bottom":"event2_bottom__Yuy34"};

/***/ }),

/***/ 94375:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18700:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25194:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(57164); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);